
$(document).ready(function() {
    $('[data-popup]').click(function() {
        popup.open($(this).attr('data-popup'), "Projektausdruck", "width=850,height=800,resizable=no");
        return false;
    });
});

var popup = {

    open: function(url, title, width, height) {
        window.open(url, title, 'width='+(width || 400)+',height='+(height || 600)+',resizable=no,scrollbars=yes');
    }

};
window.popup = popup;
